import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Inicio", href: "/" },
  { label: "Servicios", href: "/servicios" },
  { label: "Colaboradores", href: "/colaboradores" },
  { label: "Blog", href: "/blog" },
  { label: "Contacto", href: "/#contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleAnchorClick = (href: string) => {
    setMenuOpen(false);
    if (href.startsWith("/#")) {
      const id = href.replace("/#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/b4936df4b10639d97e7d05f0664429e8/104c2598f5e3c3d899cf508a4fdb8b56.png"
            alt="Fair Play Global"
            className="h-20 w-auto object-contain"
          />
        </Link>

        {/* Desktop menu */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) =>
            link.href.startsWith("/#") ? (
              <button
                key={link.label}
                onClick={() => handleAnchorClick(link.href)}
                className={`text-sm font-body font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled ? "text-brand-black hover:text-brand-red" : "text-brand-black hover:text-brand-red"
                }`}
              >
                {link.label}
              </button>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                className={`text-sm font-body font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.href
                    ? "text-brand-red"
                    : scrolled
                    ? "text-brand-black hover:text-brand-red"
                    : "text-brand-black hover:text-brand-red"
                }`}
              >
                {link.label}
              </Link>
            )
          )}
          <button
            onClick={() => handleAnchorClick("/#contacto")}
            className="bg-brand-red hover:bg-brand-red-hover text-white text-sm font-body font-medium px-5 py-2 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Solicitar información
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl text-brand-black`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white w-full border-t border-brand-pearl px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) =>
            link.href.startsWith("/#") ? (
              <button
                key={link.label}
                onClick={() => handleAnchorClick(link.href)}
                className="text-left text-base font-body font-medium text-brand-black hover:text-brand-red transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                className={`text-base font-body font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.href ? "text-brand-red" : "text-brand-black hover:text-brand-red"
                }`}
              >
                {link.label}
              </Link>
            )
          )}
          <button
            onClick={() => handleAnchorClick("/#contacto")}
            className="bg-brand-red hover:bg-brand-red-hover text-white text-sm font-body font-medium px-5 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap w-full text-center"
          >
            Solicitar información
          </button>
        </div>
      )}
    </nav>
  );
}